"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enL18n = {
    write: "Write",
    preview: "Preview",
    uploadingImage: "Uploading image..."
};
